import styled from 'styled-components'

export default styled.div`
  position: relative;
  height: 100%;

  .map-warnings {
    position: absolute;
    top: 20px;
    left: 20px;
    display: flex;
    flex-direction: row;
    gap: 8px;
  }

  .alterations-icon {
    width: 40px;
    height: 40px;
    background-color: ${ ({theme}) => theme.colors.white};
    border-radius: 50%;
    cursor: pointer;

    img {
      width: 40px;
      height: 40px;
    }
  }
`
